var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 -0.5 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.125,
  d: "M6 9.5v1m0-1c-1.84 0-2.93-1.13-3.5-2m3.5 2c1.84 0 2.93-1.13 3.5-2M8 3.5v2c0 1.1-.9 2-2 2s-2-.9-2-2v-2c0-1.1.9-2 2-2s2 .9 2 2"
})));
export default SvgMic;